import {isString, mapValues, isArray} from 'lodash-es';

import APIFetcher from '../APIFetcher';

class AssignmentApi {
  static get(query) {
    let queryString = null;
    if (isString(query)) {
      queryString = query;
    } else {
      // Convert arrays to CSV.
      const flatQuery = mapValues(query, (value) => (
        isArray(value) ? value.join(',') : value
      ));
      queryString = APIFetcher.stringifyParams(flatQuery);
    }

    return APIFetcher.get(`assignment/?${queryString}`);
  }

  static getById(id) {
    return APIFetcher.get(`assignment/${id}`);
  }

  static post(body) {
    const url = `assignment/${body.id + '/' || ''}`;
    return APIFetcher.post(url, {
      payload: body
    });
  }
}

export default AssignmentApi;
